import { render, staticRenderFns } from "./registListPage.vue?vue&type=template&id=32222960&"
import script from "./registListPage.vue?vue&type=script&lang=js&"
export * from "./registListPage.vue?vue&type=script&lang=js&"
import style0 from "./registListPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32222960')) {
      api.createRecord('32222960', component.options)
    } else {
      api.reload('32222960', component.options)
    }
    module.hot.accept("./registListPage.vue?vue&type=template&id=32222960&", function () {
      api.rerender('32222960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/registListPage.vue"
export default component.exports